/**
 * Live feedback, computed from the pearls and the drawn segments alone (CLAUDE.md §10): the
 * loop of the answer key never reaches this code.
 */
import type { Feedback } from "../types";
import { contradictions } from "./loop";
import { resizeEdges, resizePearls } from "./progress";
import { cellId, edgeKey, type MasyuDefinition, type MasyuProgress } from "./types";

export const PEARL_CONTRADICTION = "pearl_contradiction";
export const CELL_CONTRADICTION = "cell_contradiction";
export const PREMATURE_LOOP = "premature_loop";

export function liveContradictions(definition: MasyuDefinition, progress: MasyuProgress) {
  const { rows, cols } = definition;
  return contradictions(
    resizePearls(definition.pearls, rows, cols),
    resizeEdges(progress, rows, cols),
    rows,
    cols,
  );
}

export function localFeedback(definition: MasyuDefinition, progress: MasyuProgress): Feedback[] {
  const found = liveContradictions(definition, progress);
  const feedback: Feedback[] = [
    ...found.pearls.map(([r, c]) => ({
      type: "pearl",
      code: PEARL_CONTRADICTION,
      cells: [cellId(r, c)],
    })),
    ...found.cells.map(([r, c]) => ({
      type: "cell",
      code: CELL_CONTRADICTION,
      cells: [cellId(r, c)],
    })),
  ];
  if (found.loop.length > 0)
    feedback.push({ type: "loop", code: PREMATURE_LOOP, cells: found.loop.map(edgeKey) });
  return feedback;
}
